import React from 'react'

function TechnicalSupport() {
    return (
        <>
            <head>
                <title>حلول محاسبية دقيقة توفر وقتك ومالك</title>
                <meta name="description" content="نقدم حلول محاسبية دقيفة توفر الوفت والجهد" />
            </head>
            <div>
                <h1>دعم فني متواصل.. لا مكان للأعطال</h1>
                <p>
                    لا داعي للقلق من الأعطال التقنية بعد اليوم! فريق الدعم الفني في بروتك المتحدة يعمل على مدار الساعة لتقديم:
                </p>
                <ol>
                    <li>  حلول سريعة لأعطال البرمجيات والأنظمة.</li>
                    <li> صيانة دورية لمنع المشكلات قبل حدوثها.</li>
                    <li> استجابة فورية عبر عدة قنوات (هاتف، إيميل، شات مباشر).</li>
                </ol>
            </div>
        </>
    )
}

export default TechnicalSupport